import * as User from './User';

export default User;
